import React from "react";
import useAppModalService from "../../hooks/useAppModalService";
import {ModalResultType, ModalType} from "../../components/AppModal/ModalTypes";
import {Modal} from "@mui/material";
import {useEffect} from "react";
import OnBoardingPopUp from "../PopUps/OnBoardingPopUp/OnBoardingPopUp";
import UnAvailableContestsPopUp from "../PopUps/UnAvailableContestsPopUp/UnAvailableContestsPopUp";
import {useDispatch, useSelector} from "react-redux";
import {selectPreSelectedParlayById} from "../../stores/pickX/pickX.selectors";
import pickXApi from "../../stores/pickX/pickX.api";
import PrizeAssetWelcomePopUp from "../PopUps/WelcomePopUps/PrizeAssetWelcomePopUp";

const LoginModal = ({id, title, subTitle, open, onClose, onCancel, onOk, options, data})=>{
    return <Modal
        id={id}
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
    >
        <div>
            <div id="modal-modal-title" variant="h6" component="h2">
                {title}
            </div>
            <div id="modal-modal-description" sx={{ mt: 2 }}>
                {subTitle}
            </div>
            <button onClick={()=>onOk({success:true})}>OK</button>
        </div>
    </Modal>;
}


const TestView = ({}) => {
    const modalServices = useAppModalService();

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(pickXApi.endpoints.getPreSelectedParlayById.initiate("689d0901cd7d9751f48ccb4b"))
    },[])

    const handleOpenModal = async ()=>{
        const data = {x:1,y:2};
       /* const infoRes = await modalServices.openModal("modalId", ModalType.CUSTOM, {
            modalComponent: OnBoardingPopUp,
            onOk: (res)=>{
                return res; //payload
            }
        }, data )

        if (infoRes.result === ModalResultType.OK){
            console.log("User Click ok");
        }*/

        modalServices.openModal('unAvailableContestsPopUp', 'info', {
            title: 'UnAvailable Contests',
            modalComponent: UnAvailableContestsPopUp,
            onOk: () => {
                //navigate('/lobby');
            },
        })
    }

    /*useEffect(() => {
        handleOpenModal();
    }, []);*/



    const preSelectedParlay = useSelector(state=>selectPreSelectedParlayById(state, '689d0901cd7d9751f48ccb4b'));

    useEffect(()=>{
        if(preSelectedParlay){
            modalServices.openModal('preSelectedParlayWelcomePopUp', ModalType.CUSTOM, {
                modalComponent: PrizeAssetWelcomePopUp,
                onOk: () => {
                    //navigate('/lobby');
                }
            }, {
                preSelectedParlay
            })
        }
    },[preSelectedParlay])

    return <div style={{marginTop: 100}}>
        <button onClick={()=>handleOpenModal()}>Open Modal</button>
    </div>;

}
export default TestView;